import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
export default {
  data() {
    return {
      hoverIndex: -1,
      animatedCards: [],
      isAnimated: false,
      monetizationData: [{
        label: "智能算法引擎",
        content: "高效自动，收益至少高30%",
        img: "m-1.jpg"
        // hoverImg: "gm-1.gif",
      }, {
        label: "结算周期灵活",
        content: "周结/月结",
        img: "m-2.jpg"
        // hoverImg: "gm-2.gif",
      }, {
        label: "定期广告优化",
        content: "助力媒体随时随地洞察业务",
        img: "m-3.jpg"
        // hoverImg: "gm-3.gif",
      }, {
        label: "7*24小时服务",
        content: "24小时回应，多维度配合",
        img: "m-4.jpg"
        // hoverImg: "gm-4.gif",
      }]
    };
  },
  methods: {
    getImagePath(imageName) {
      return require(`../../assets/images/${imageName}`);
    },
    setHoverIndex(activeIndex) {
      this.hoverIndex = activeIndex;
      this.monetizationData.forEach((item, index) => {
        this.$set(item, "isAnimated", index === activeIndex);
      });
    },
    // getDisplayImage(index) {
    // if (this.hoverIndex === index && this.monetizationData[index].hoverImg) {
    //   return this.monetizationData[index].hoverImg;
    // }
    // return this.monetizationData[index].img;
    // },

    getCardAnimationClasses(index) {
      const isAnimated = this.animatedCards.includes(index);
      return {
        animate__animated: isAnimated,
        animate__fadeInUp: isAnimated,
        "card-visible": isAnimated // 添加可见状态
      };
    },
    startAnimation() {
      // 较短的延迟开始卡片动画
      setTimeout(() => {
        this.startCardAnimations();
      }, 500); // 减少延迟时间
    },
    startCardAnimations() {
      this.monetizationData.forEach((item, index) => {
        setTimeout(() => {
          this.animatedCards.push(index);
        }, index * 150); // 减少每个卡片的延迟
      });
    }
  }
};